import React from "react";
import { ListSubheader, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { VoicesPostTarget } from "../../../Models/voicesPosts";
import { VoicesPerson } from "../../../Models/voicesProfiles";
import { useVoicesCompanyPages, useVoicesPeople } from "../../../Query/useVoicesProfiles";
import VoicesInput from "../Common/VoicesInput";

interface Props {
  value: VoicesPostTarget | null;
  onChange: (target: VoicesPostTarget) => void;
}

const SEPARATOR = ":";

const personName = (person?: VoicesPerson) =>
  person ? `${person.name} ${person.surname}`.trim() : undefined;

const VoicesTargetSelect: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation("voicesPosts");
  const { data: people = [] } = useVoicesPeople();
  const { data: pages = [] } = useVoicesCompanyPages();

  const posting = people.filter((person) => person.is_posting && person.profile);

  return (
    <VoicesInput
      select
      value={value ? `${value.kind}${SEPARATOR}${value.id}` : ""}
      onChange={(e) => {
        const [kind, id] = e.target.value.split(SEPARATOR);
        const name =
          kind === "company_page"
            ? pages.find((page) => page.id === Number(id))?.name
            : personName(posting.find((person) => person.user_id === Number(id)));
        onChange({ kind: kind as VoicesPostTarget["kind"], id: Number(id), name });
      }}
      helperText={!posting.length && !pages.length ? t("noTargets") : undefined}
    >
      <ListSubheader>{t("targetPeople")}</ListSubheader>
      {posting.map((person) => (
        <MenuItem key={`person-${person.user_id}`} value={`person${SEPARATOR}${person.user_id}`}>
          {personName(person)}
        </MenuItem>
      ))}
      <ListSubheader>{t("targetPages")}</ListSubheader>
      {pages.map((page) => (
        <MenuItem key={`page-${page.id}`} value={`company_page${SEPARATOR}${page.id}`}>
          {page.name}
        </MenuItem>
      ))}
    </VoicesInput>
  );
};

export default VoicesTargetSelect;
